export const ROUTES = {
  HOME_PATH: '/',

  LEARN_PATH: '/learn',
  START_APPLICATION_PATH: '/start-application',

  CONFIRMATION_PATH: '/confirmation',

  ALREADY_PURCHASED_PATH: '/already-purchased',

  BUILDING_PATH: '/building/:id',
  BUILDING_TYPE_PATH: '/building/:type/:id',

  ORGANISATION_PATH: '/organisation/:id',
  COMPANY_PATH: '/company/:name/:flow?',

  COMPLIANCE_PATH: '/compliance',
  COMPLIANCE_TERMS_PATH: '/compliance/terms',
  COMPLIANCE_PROVIDERS_PATH: '/compliance/providers',
  COMPLIANCE_WELCOME_PATH: '/compliance/welcome',
  COMPLIANCE_VERIFIED_PATH: '/compliance/verified',
  COMPLIANCE_ALREADY_VERIFIED_PATH: '/compliance/already-verified',
  COMPLIANCE_NO_POLICY_PATH: '/compliance/nopolicylocated',
  COMPLIANCE_NO_BUILDING_PATH: '/compliance/nobuildinglocated',
  COMPLIANCE_COVERAGE_NOT_COMPLIANT_PATH: '/compliance/coverage-not-compliant',
  COMPLIANCE_UPLOAD_SUCCESS_PATH: '/compliance/upload-success',
  COMPLIANCE_COVIE_PATH: '/compliance/:covie_id',

  QUOTE_INFORMATION_PATH: '/quote-information',

  COVERAGES_DETAIL_PATH: '/coverages-details',

  PAYMENT_PATH: '/payment',
  PAYMENT_CROSS_SELL_PATH: '/payment-cross-sell',

  SERVICE_TERMS_PATH: '/service/terms-and-conditions',
  SERVICE_CONSUMER_REPORTS_NOTICE_PATH: '/service/consumer-reports-notice',

  ERROR_PATH: '/error',
} as const;
